module.exports = __webpack_public_path__ + "img/6.ccaaa0ec.jpg";